import type { ApiClientOptions } from '@/infra/api-client'
import { patchGrpcClient } from '@/utils/grpc-util'
import { OpportunityServicePromiseClient } from '@taxfyle/api-internal/internal/opportunity_grpc_web_pb'
import type { RealtimeEvent } from '@taxfyle/api-internal/internal/realtime_pb'
import type { Observable } from 'rxjs'

/**
 * Opportunities endpoints of the work API.
 */
export class OpportunitiesApi {
  readonly opportunities

  constructor(
    options: ApiClientOptions,
    readonly realtime$: Observable<RealtimeEvent>,
  ) {
    this.opportunities = new OpportunityServicePromiseClient(
      options.baseURL ?? '',
    )
    patchGrpcClient(this.opportunities, options.token$)
  }
}
